import { getApiUrlWithPath } from 'services/backofficeIntegration/http/apiUrlUtils';

export const getDataScienceApiUrl = () => getApiUrlWithPath('/api');
